import { render, staticRenderFns } from "./dishes-list.vue?vue&type=template&id=2643fa02&scoped=true"
import script from "./dishes-list.vue?vue&type=script&lang=js"
export * from "./dishes-list.vue?vue&type=script&lang=js"
import style0 from "./dishes-list.vue?vue&type=style&index=0&id=2643fa02&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2643fa02",
  null
  
)

export default component.exports